<template>
<van-skeleton  :row="25" :loading="ske"> 
    <div id="vip"> 
        <mt-header fixed title="仓库"><mt-button icon="back" slot="left" @click="back"></mt-button></mt-header>
        <ul>
            <li @click="fahuo"><img src="../../assets/images/can2.png" alt=""><span class="canku">我的发货</span></li>
            <li @click="yaofa"><img src="../../assets/images/can1.png" alt=""><span class="canku">我要发货</span></li>
        </ul>
    </div>
</van-skeleton>
</template>
<script> 
import { Toast } from "vant";
export default {
    data(){
        return{ 
            ske:true, 
        }
    },
    created(){ 
        this.ske=false;
    },  
     methods: { 
         back(){ 
            this.$router.push("/MyIndex"); 
         },
         fahuo(){
             this.$router.push({ name: "faHuo"});
         },
         yaofa(){
              this.$router.push({ name: "yaoFa"});
         }
    }
}
</script>
<style  lang="scss" scoped> 
 ul{
     display:flex;
     padding:0rem .1rem;
     margin-top:.55rem;
     li:nth-of-type(odd){
         margin-right:2%;
     }
     li{
         width:49%;
         position:relative;
         >img{
             width:100%;
         }
         span{
             font-size:.19rem;
             color:white;
             position: absolute;
             bottom:.3rem;
             left:29%;
         }
     }
 }
</style>